import _extends from "@babel/runtime/helpers/extends";
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { SkeletonRectangle } from '@wix/design-system';
import { SearchRecommendationLayout } from '@wix/domains-search-suite';
import s from './LazyRecommendationLabel.scss';
import React from 'react';
export const LazyRecommendationLabel = _ref => {
  let isLoadingLabels = _ref.isLoading,
    matchLabels = _ref.matchLabels,
    _ref$primary = _ref.primary,
    primary = _ref$primary === void 0 ? false : _ref$primary,
    labelClassName = _ref.labelClassName;
  const LabelContainer = _ref2 => {
    var _matchLabels$find;
    let premium = _ref2.premium,
      visible = _ref2.visible,
      children = _ref2.children,
      domain = _ref2.domain,
      existingLabel = _ref2.label;
    const matchingLabel = (!existingLabel || existingLabel === RecommendationLabel.UNKNOWN_LABEL) && (matchLabels == null || (_matchLabels$find = matchLabels.find(label => label.domain === domain)) == null ? void 0 : _matchLabels$find.label);
    if (!visible && !isLoadingLabels && !matchingLabel) {
      return null;
    }
    return /*#__PURE__*/React.createElement(SearchRecommendationLayout.LabelContainer, {
      premium: premium,
      visible: true,
      domain: domain
    }, !visible && isLoadingLabels ? /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeleton,
      width: "82px",
      height: "20px"
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, matchingLabel && /*#__PURE__*/React.createElement(SearchRecommendationLayout.Label, _extends({
      primary: primary,
      label: matchingLabel,
      domain: domain
    }, labelClassName && {
      className: labelClassName
    })), children));
  };
  return /*#__PURE__*/React.memo(LabelContainer);
};
//# sourceMappingURL=LazyRecommendationLabel.js.map